import { GridItem, GridItemProps, Text, useColorModeValue } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { prettyCurrency } from '@pelicargo/utils';

type LineItemHeaderProps = GridItemProps & {
  label: string;
  perUnitValue: number;
  totalCost: number;
};

export const LineItemHeader = ({ label, perUnitValue, totalCost, ...rest }: LineItemHeaderProps) => {
  const bgColor = useColorModeValue('gray.100', 'gray.700');

  return (
    <>
      <GridItem pl="4" colSpan={3} bgColor={bgColor} {...rest}>
        <Text textStyle="label" py="1.5">
          {label}
        </Text>
      </GridItem>
      <GridItem textAlign="right" colSpan={1} bgColor={bgColor} {...rest}>
        <Show if={perUnitValue > 0}>
          <Text textStyle="label" py="1.5">
            {prettyCurrency(perUnitValue)}/kg
          </Text>
        </Show>
      </GridItem>
      <GridItem textAlign="right" pr="4" colSpan={1} bgColor={bgColor} {...rest}>
        <Show if={totalCost > 0}>
          <Text textStyle="label" py="1.5">
            {prettyCurrency(totalCost)}
          </Text>
        </Show>
      </GridItem>
    </>
  );
};
